export default {
  model (resource) {
    return Object.assign({
      title: '',
      customerId: null,
      description: '',
      type: 'SALE',
      status: 'En Proceso',
      quantity: null,
      brand: '',
      model: '',
      machineryType: ''
    }, resource)
  },
  rules () {
    return {
      customerId: [
        {required: true, message: 'La fecha es requerida'}
      ],
      title: [
        {required: true, message: 'El título es requerido'}
      ],
      type: [
        {required: true, message: 'El tipo es requerido'}
      ],
      status: [
        {required: true, message: 'El estatus es requerido'}
      ],
      machineryType: [
        {required: true, message: 'El tipo de maquinaria es requerido'}
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/opportunities/opportunities-model.js